import { render, staticRenderFns } from "./ReferralLeakageAuditPage.vue?vue&type=template&id=7f12d6ac&scoped=true"
import script from "./ReferralLeakageAuditPage.vue?vue&type=script&lang=js"
export * from "./ReferralLeakageAuditPage.vue?vue&type=script&lang=js"
import style0 from "./ReferralLeakageAuditPage.vue?vue&type=style&index=0&id=7f12d6ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f12d6ac",
  null
  
)

export default component.exports